import React, { Component } from 'react';
import Select from 'react-select';
import type { MultiValue } from 'react-select';

interface ISelectPanelProps {
    cancelLabel: string;
    isMulti: boolean;

    label: string;
    onChange?: (() => void) | undefined;
    onClickCancel?: (() => void) | undefined;
    onClickSave?: ((items: any) => void) | undefined;
    onClickSelectedOption?: (() => void) | undefined;

    options: string[];
    optionsSelected: string[] | null | undefined;

    optionLabel: (option: string) => string;
    optionValue: (option: string) => string;

    saveLabel: string;
    isFieldsOfSupport: boolean;
}

interface ISelectPanelState {
    selectedOptions: string[];
}

type Option = { value: string; label: string };

export class SelectPanel extends Component<
    ISelectPanelProps,
    ISelectPanelState
> {
    private stateCopy: ISelectPanelState;

    constructor(props: ISelectPanelProps) {
        super(props);

        this.state = {
            selectedOptions: this.props.optionsSelected ?? [],
        };

        this.stateCopy = { ...this.state };
    }

    componentDidUpdate(prevProps: ISelectPanelProps) {
        if (prevProps.optionsSelected !== this.props.optionsSelected) {
            this.setState({
                selectedOptions: this.props.optionsSelected ?? [],
            });
            this.copyCurrentState();
        }
    }

    callFunctionIfDefined(method: (() => void) | undefined = undefined): void {
        if (method) {
            method();
        }
    }

    copyCurrentState(): void {
        this.stateCopy = { ...this.state };
    }

    onClickCancel = (e?: React.MouseEvent) => {
        if (e) e.preventDefault();
        this.setState({ ...this.stateCopy });
        this.callFunctionIfDefined(this.props.onClickCancel);
    };

    onClickSave = (e?: React.MouseEvent) => {
        if (e) e.preventDefault();
        this.copyCurrentState();
        this.props.onClickSave?.(this.state.selectedOptions);
    };

    onChange = (option: MultiValue<Option>) => {
        const selectedOptions = option.map((o) => o.value);
        this.setState({ selectedOptions });
        this.callFunctionIfDefined(this.props.onChange);
    };

    onClickSelectedOption = (option: string, e?: React.MouseEvent) => {
        if (e) e.preventDefault();

        const idx = this.state.selectedOptions.indexOf(option);
        if (idx === -1) return;

        const selectedOptions = [...this.state.selectedOptions];
        selectedOptions.splice(idx, 1);

        this.setState({ selectedOptions });
        this.callFunctionIfDefined(this.props.onChange);
    };

    render() {
        const options: Option[] = this.props.options.map((o) => ({
            value: this.props.optionValue ? this.props.optionValue(o) : o,
            label: this.props.optionLabel ? this.props.optionLabel(o) : o,
        }));

        const value: Option[] = this.state.selectedOptions.map((o) => ({
            value: o,
            label: o,
        }));

        return (
            <>
                <div
                    className="dropdown-body"
                    onClick={(e) => e.stopPropagation()}
                >
                    <form data-captcha-initialized="true">
                        <div className="form-group">
                            <Select<Option, true>
                                aria-label={this.props.label}
                                className="filter-select-container"
                                classNamePrefix="filter-select"
                                hideSelectedOptions={false}
                                placeholder={this.props.label}
                                options={options}
                                getOptionLabel={(opt: Option) => opt.label}
                                getOptionValue={(opt: Option) => opt.value}
                                isMulti
                                value={value}
                                onChange={this.onChange}
                            />
                            {this.state.selectedOptions.length > 0 && (
                                <div className="selected-value">
                                    {this.state.selectedOptions.length}{' '}
                                    {this.props.label}
                                </div>
                            )}
                        </div>

                        {this.state.selectedOptions.length > 0 && (
                            <div className="chips">
                                {this.state.selectedOptions.map((item) => (
                                    <span className="chip" key={item}>
                                        {item}
                                        <button
                                            aria-label={this.props.cancelLabel}
                                            className="btn-no-look"
                                            onClick={(e) =>
                                                this.onClickSelectedOption(
                                                    item,
                                                    e
                                                )
                                            }
                                        >
                                            <i className="icon-cross"></i>
                                        </button>
                                    </span>
                                ))}
                            </div>
                        )}
                    </form>
                </div>

                <div className="dropdown-footer">
                    <a
                        href="#"
                        className="primary"
                        onClick={this.onClickCancel}
                    >
                        {this.props.cancelLabel}
                    </a>

                    {this.props.isFieldsOfSupport ? (
                        <a
                            href="#"
                            className="btn-secondary gtm-fieldsOfSupport"
                            data-gtmFieldOfSupports={this.state.selectedOptions.join(
                                ','
                            )}
                            onClick={this.onClickSave}
                        >
                            {this.props.saveLabel}
                        </a>
                    ) : (
                        <a
                            href="#"
                            className="btn-secondary"
                            onClick={this.onClickSave}
                        >
                            {this.props.saveLabel}
                        </a>
                    )}
                </div>
            </>
        );
    }
}
